import React, {Component} from 'react';
import {
  Box,
  Grid,
  Typography
} from '@material-ui/core';
import {
  Table
} from './components';
import {
  Page,
  WithoutAccess
} from '../../../components';
import {
  getPageFromCount
} from '../../../common/pagination';
import axios from '../../../plugins/axios';

const initialFilter = {
  page: 1,
  limit: 20
};

class FeedbackList extends Component {
  constructor(props) {
    super(props);

    const isAdmin = Boolean(props.user?.role === 'admin');

    this.state = {
      rows: [],
      filter: {...initialFilter},
      pagination: {
        page: 1
      },
      isLoading: true,
      isAdmin
    }
  }

  componentDidMount = () => {
    if (this.state.isAdmin) {
      this.getListFeedback();
    }
  }

  getListFeedback = () => {
    this.setState({isLoading: true});

    axios('post', '/feedback/get', this.state.filter).then((response) => {
      const {data, headers} = response;
      let pagination = {...this.state.pagination};
      pagination.page = getPageFromCount(headers['x-pagination-total-count'], this.state.filter.limit);

      this.setState({
        rows: data || [],
        pagination,
        isLoading: false
      });
    }).catch(() => {
      this.setState({
        rows: [],
        isLoading: false
      });
    });
  }

  onChangeFilter = (filter, isFastStart) => {
    this.setState({filter}, () => {
      if (isFastStart) {
        this.getListFeedback();
      }
    });
  }

  render() {
    const {
      rows,
      filter,
      pagination,
      isLoading,
      isAdmin
    } = this.state;

    if (!isAdmin) {
      return (
        <WithoutAccess/>
      )
    }

    return (
      <Page title="История обращений">
        <Box mb={2}>
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography variant="h1">История обращений</Typography>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <Table
            rows={rows}
            filter={filter}
            pagination={pagination}
            isLoading={isLoading}
            onChangeFilter={this.onChangeFilter}
          />
        </Box>
      </Page>
    );
  }
}

export default FeedbackList
